class MenuDrawer extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        sidebarDrawer: this.querySelector('.menu-drawer'),
        sidebarDrawerButton: this.querySelectorAll('.menu-drawer__close .button-close'),
        focusableElements: Array.from(this.querySelectorAll('summary, a[href], button:enabled, [tabindex="0"], [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'))
      };
      document.querySelectorAll('.burger-menu').forEach(item => item.addEventListener('click', this.openDrawer.bind(this)));
      if (Shopify.designMode) {
        document.querySelector('#shopify-section-menu-drawer').addEventListener('shopify:section:select', this.openDrawer.bind(this));
        document.querySelector('#shopify-section-menu-drawer').addEventListener('shopify:section:deselect', this.closeDrawer.bind(this));
        document.querySelector('#shopify-section-menu-drawer').addEventListener('shopify:section:unload', this.openDrawer.bind(this))
        window.addEventListener('shopify:section:load', () => document.querySelectorAll('.burger-menu').forEach(item => item.addEventListener('click', this.openDrawer.bind(this))))
      }

      this.elements.sidebarDrawerButton.forEach(item => item.addEventListener('click', this.closeDrawer.bind(this)));
        document.addEventListener('keyup', (event) => {
          if (event.code?.toUpperCase() === 'ESCAPE' && !event.target.closest('.search-modal') && !document.querySelector('.search-modal.open') && this.elements.sidebarDrawer.classList.contains('open')) this.closeDrawer()
        })
    }
  
    openDrawer(event) {
      if (this.elements.sidebarDrawer.classList.contains('open')) return;
      this.opener = event?.currentTarget?.matches('.burger-menu') ? event.currentTarget : document.activeElement;
      this.opener?.setAttribute('aria-expanded', 'true');
      this.elements.sidebarDrawer.removeAttribute('hidden')
      this.elements.sidebarDrawer.classList.add('open');
      document.body.classList.add('hidden')
      trapFocus(this.elements.sidebarDrawer, this.elements.sidebarDrawerButton[0]);
    }
  
    closeDrawer() {
      this.elements.sidebarDrawer.setAttribute('hidden', 'true')
      this.elements.sidebarDrawer.classList.remove('open')
      this.opener?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('hidden')
      document.dispatchEvent(new CustomEvent('body:visible'));
      removeTrapFocus(this.opener);
    }
  }
  customElements.define('menu-drawer', MenuDrawer);  
